import React from 'react';
import SectionSubtitle from '@/components/Typography/SectionSubtitle';
import { InspectionList } from '@/components/InspectionList';
import CardSectionRateWide from '@/components/CardSectionWideRate';
import { InspectionItem } from '@/components/InspectionList/InspectionList.types';
import { RatingSection } from '@/api/mappers/mapper-types';
import { CardSectionRate, SectionSummary, SVGIcon, TextSummaryBox } from '@/components';
import { SectionNoData } from '@/components/SectionNoData';

interface RaportTestDriveProps {
  /** Sekcja oceny jazdy próbnej z tytułem, ratingiem i opisem */
  ratingSection: RatingSection;
  /** Lista uwag dotyczących jazdy próbnej */
  remarks: string[];
  /** Lista elementów do weryfikacji podczas jazdy próbnej */
  testDriveItems: InspectionItem[];
  /** Podsumowanie rzeczoznawcy dotyczące jazdy próbnej */
  expertSummary: string | null;
  /** Kto prowadził pojazd podczas jazdy próbnej */
  drivenBy: string | null;
}

export default function RaportTestDrive({
  ratingSection,
  remarks,
  testDriveItems,
  expertSummary,
  drivenBy,
}: RaportTestDriveProps) {
  return (
    <>
      <div className="mt-[58px] w-full" id="podsumowanie-jazdy-probnej">
        <SectionSubtitle
          title="Podsumowanie jazdy próbnej"
          description="Ocena punktowa oraz zestawienie uwag."
        />

        {ratingSection.rating !== null ? (

          <div className="flex flex-col gap-11 items-start mt-11 md:flex-row">
            {
              ratingSection.rating === 5 ?
                <CardSectionRateWide
                  title={ratingSection.title}
                  maxRating={5}
                  rating={ratingSection.rating}
                  description={'Wygląda na to, że nasza ekspertyza nie wykazała żadnych nieprawidłowości w ocenie jazdy próbnej.'}
                  ratingMessage={ratingSection.ratingMessage}
                /> : (
                  <>
                    <CardSectionRate
                      title={ratingSection.title}
                      maxRating={5}
                      rating={ratingSection.rating}
                      description={ratingSection.description || ''}
                      ratingMessage={ratingSection.ratingMessage}
                    />
                    {remarks.length > 0 && <TextSummaryBox title="Uwagi" items={remarks} />}
                  </>
                )
            }
          </div>
        ) : <div className="py-6">
          <SectionNoData
            title="Ocena jazdy próbnej w przygotowaniu"
            description="Rzeczoznawca pracuje nad oceną jazdy próbnej. Ocena będzie dostępna wkrótce."
          />
        </div>}
      </div>

      {testDriveItems.length > 0 && (
        <div className="mt-20" id="szczegolowy-raport-jazdy-probnej">
          <SectionSubtitle
            title="Szczegółowy raport z jazdy próbnej"
            description="Weryfikacja jazdy próbnej – sprawdzenie funkcjonowania elementów podczas jazdy."
          />
          <div className="mt-10">
            {
              drivenBy && (
                <div className="mb-3 text-lg font-bold text-left text-text-primary">
                  Pojazd prowadził:&nbsp;
                  <span className="text-blue">{drivenBy}</span>
                </div>
              )
            }
            <InspectionList
              items={testDriveItems}
              remarks={remarks}
            />

            {expertSummary && (
              <div className="mt-20 md:mt-0 md:px-8">
                <SectionSummary
                  iconName="steering"
                  title="Podsumowanie Rzeczoznawcy dotyczące jazdy próbnej"
                  content={expertSummary}
                  className="md:border-t-0 md:rounded-t-none"
                />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
